import { AttachmentService } from 'src/app/services/attachment.service';
import { LoadingService } from './../../../services/loading.service';
import { VehicleReservationState } from './../../../models/enums/BookingEnums';
import { AuthService } from './../../../services/auth.service';
import { element } from 'protractor';
import { BookingService } from './../../../services/booking.service';
import { Router } from '@angular/router';
import { LoginModalBodyComponent } from './../login-modal-body/login-modal-body.component';
import { ReviewsModalBodyComponent } from './../../search-location/reviews-modal-body/reviews-modal-body.component';
import { SearchService } from 'src/app/services/search.service';
import { ChangeDetectorRef, Component, OnInit, OnDestroy } from '@angular/core';
import { faChevronCircleLeft, faChevronCircleRight, faBriefcase, faGasPump, faUser, faMapMarkerAlt, faCar, faKey, faTags, faDollarSign, faRoad, faBatteryHalf, faBan } from '@fortawesome/free-solid-svg-icons';
import { DomSanitizer } from "@angular/platform-browser";
import { MatDialog, MatDialogConfig } from "@angular/material/dialog";
import { MatIconRegistry } from "@angular/material/icon";
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { VehicleSearchTypeEnum } from 'src/app/models/enums/VehicleSearchTypeEnum';
import { ViewEncapsulation, AfterViewInit, ViewChild, ElementRef } from '@angular/core';
import { CountdownComponent } from 'ngx-countdown';
import { MyBookingModel } from 'src/app/models/Booking/MyBookingModel';
import { Vehicle } from 'src/app/models/Vehicle';
import { IconService } from './../../../services/icon.service';
import { AttachmentScopesEnum, AttachmentTypeEnum } from 'src/app/models/enums/Attachment/AttachmentEnum';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { Customer } from 'src/app/models/Customer';
import { Subscription } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'my-bookings',
  templateUrl: './my-bookings.component.html',
  styleUrls: ['./my-bookings.component.scss']
})
export class MyBookingsComponent implements OnInit, OnDestroy {
  MakeModelYearSearch: boolean = false;
  vehicleSearch: boolean = false;
  classSearch: boolean = false;
  showCountDown = true;
  thierIsBokking = true;
  faBriefcase = faBriefcase;
  faGasPump = faGasPump;
  faUser = faUser;
  faMapMarkerAlt = faMapMarkerAlt;
  faCar = faCar;
  faKey = faKey;
  faTags = faTags;
  faDollarSign = faDollarSign;
  faRoad = faRoad;
  faBatteryHalf = faBatteryHalf;
  faBan = faBan;
  faChevronCircleLeft = faChevronCircleLeft;
  faChevronCircleRight = faChevronCircleRight;

  vehicle: Vehicle;
  currency;
  duration;
  myBookings: MyBookingModel[];

  isLinear = true;
  firstFormGroup: FormGroup;
  secondFormGroup: FormGroup;
  math = Math;
  myBookingsFilter: MyBookingModel[] = null;
  loggedInCustomer: Customer;
  subscriptions: Subscription[] = [];

  pageSize: number = 5;
  pageNumber: number = 1;
  totalCount: number;
  selectedVehicleReservationState;
  daysResource: string;
  hoursResource: string;
  minutesResource: string;
  secondsResource: string;

  intervals:NodeJS.Timeout[]=[];

  constructor(
    private cd: ChangeDetectorRef,
    private loadingService: LoadingService,
    private _formBuilder: FormBuilder, service: SearchService,
    private authService: AuthService,
    private matIconRegistry: MatIconRegistry,
    private domSanitizer: DomSanitizer,
    private dialog: MatDialog,
    private bookingService: BookingService,
    private router: Router,
    private iconService: IconService,
    private attachmentService: AttachmentService,
    private translateService: TranslateService) {

    //this.myBookings=bookingService.getMyBookings();

    //this.vehicle = service.getVehicle();
    this.currency = service.getCurrency();

    // this.matIconRegistry.addSvgIcon(
    //   "car-gear",
    //   this.domSanitizer.bypassSecurityTrustResourceUrl(iconService.carGearIcon)
    // );
    // this.matIconRegistry.addSvgIcon(
    //   "car-door",
    //   this.domSanitizer.bypassSecurityTrustResourceUrl(iconService.carDoorIcon)
    // );
    this.matIconRegistry.addSvgIcon(
      "timeIcon",
      this.domSanitizer.bypassSecurityTrustResourceUrl(iconService.timeIcon)
    );
    this.matIconRegistry.addSvgIcon(
      "supplierMapIcon",
      this.domSanitizer.bypassSecurityTrustResourceUrl(iconService.supplierMapIcon)
    );

    this.matIconRegistry.addSvgIcon(
      "noAvailableRental",
      this.domSanitizer.bypassSecurityTrustResourceUrl(iconService.noAvailableRental)
    );

  }

  get attachmentScopesEnum() {
    return AttachmentScopesEnum;
  }
  get attachmentTypeEnum() {
    return AttachmentTypeEnum;
  }

  get vehicleReservationState() {
    return VehicleReservationState;
  }

  openDialog() {
    const dialogConfig = new MatDialogConfig();
    this.dialog.open(ReviewsModalBodyComponent, dialogConfig);
  }




  calculateCountDown(startDate, caseID, daysResource, hoursResource, minutesResource, secondsResource) {


    
    var counterInterval;
    var updateCountDown = function () {
      try {
        //Ref https://www.w3schools.com/howto/howto_js_countdown.asp
        var elementID = 'countdown_' + caseID;
        var countDownDate = new Date(startDate).getTime();

        // Get today's date and time
        var now = new Date().getTime();

        // Find the distance between now and the count down date
        var distance = countDownDate - now;
        // Time calculations for days, hours, minutes and seconds
        var days = Math.floor(distance / (1000 * 60 * 60 * 24));
        var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        var seconds = Math.floor((distance % (1000 * 60)) / 1000);


        document.getElementById(caseID + '_days').innerHTML = days + "<br /> <span class=\"count-down-text\">" + daysResource + " </span> ";
        document.getElementById(caseID + '_hours').innerHTML = hours + "<br /> <span class=\"count-down-text\">" + hoursResource + "</span>";
        document.getElementById(caseID + '_minutes').innerHTML = minutes + "<br /> <span class=\"count-down-text\">" + minutesResource + "</span>";
        document.getElementById(caseID + '_seconds').innerHTML = seconds + "<br /> <span class=\"count-down-text\">" + secondsResource;





        // Output the result in an element with id="demo"
        /*       document.getElementById(elementID).innerHTML = days + "d " + hours + "h "
                + minutes + "m " + seconds + "s "; */

        // If the count down is over, write some text
        if (distance < 0) {
          document.getElementById(elementID).innerHTML = "";
          window.location.reload();

        }
      } catch (error) {
        clearInterval(counterInterval);
      }
    }

    try {
      counterInterval = setInterval(updateCountDown, 1000);

      this.intervals.push(counterInterval);
    }
    catch (error) {
      clearInterval(counterInterval);

    }

  }



  ngOnInit() {
    // this.bookingService.vehicle.subscribe(res =>{
    //    this.vehicle = res;});


    this.cd.markForCheck();
    this.subscriptions.push(this.authService.loggedInCustomer.subscribe(res => {
      if (res != null) {
        this.loggedInCustomer = res;


        this.selectedVehicleReservationState = VehicleReservationState.Confirmed;
        this.getMyBooking(this.loggedInCustomer.customerID, VehicleReservationState.Confirmed);

      }

    }, err => {

    }))

  }


  /*CountDown */
  status = 'start';
  @ViewChild('countdown') counter: CountdownComponent;
  finishTest() {
    this.status = 'finished';
    this.counter.restart();
  }
  resetTimer() {
    this.counter.restart();
  }

  getMyBooking(customerID, stateID, onScroll?) {
    if (onScroll == null) {
      //Reset Pages
      this.pageNumber = 1;
    }


    this.subscriptions.push(this.bookingService.getVehicleReservationCasesByCustomerID(customerID, this.pageSize, this.pageNumber, stateID).subscribe(res => {


      let result = res.result;
      this.totalCount = res.totalCount;

      Math.abs(2)
      result.sort(function (o1, o2) {
        return <any>new Date(o2.bookingDate) - <any>new Date(o1.bookingDate);
      });
      let _myBooking: MyBookingModel[] = [];
      result.forEach(element => {

        _myBooking.push(new MyBookingModel(element));
      });
      this.myBookingsFilter = _myBooking;




      this.cd.markForCheck();
      this.myBookings = _myBooking;
      if (this.myBookings != null) {


        this.translateService.get(['Days', 'Hours', 'Minutes', 'Seconds']).subscribe(res => {

          this.daysResource = res["Days"];
          this.hoursResource = res["Hours"];
          this.minutesResource = res["Minutes"];
          this.secondsResource = res["Seconds"];

        })
        this.myBookings.forEach(item => {

          this.calculateCountDown(item.startDateCoutDown, item.caseID, this.daysResource, this.hoursResource, this.minutesResource, this.secondsResource);
        })
      }
    }, err => {

    }));
  }
  getMyBookingOnScroll(customerID, stateID) {


    this.subscriptions.push(this.bookingService.getVehicleReservationCasesByCustomerID(customerID, this.pageSize, this.pageNumber, stateID).subscribe(res => {


      let result = res.result;



      let _myBooking: MyBookingModel[] = this.myBookingsFilter;
      result.forEach(element => {

        _myBooking.push(new MyBookingModel(element));
      });
      this.myBookingsFilter = _myBooking;


      this.cd.markForCheck();
      this.myBookings = _myBooking;
      if (result != null) {
        this.translateService.get(['Days', 'Hours', 'Minutes', 'Seconds']).subscribe(res => {

          this.daysResource = res["Days"];
          this.hoursResource = res["Hours"];
          this.minutesResource = res["Minutes"];
          this.secondsResource = res["Seconds"];
        })

        result.forEach(item => {

          this.calculateCountDown(item.startDateCoutDown, item.caseID,this.daysResource, this.hoursResource, this.minutesResource, this.secondsResource);
        })
      }
    }, err => {

    }));
  }



  viewBooking(myBookings: MyBookingModel) {
    this.router.navigate(['/view-booking', { CaseID: myBookings.caseID }]);
  }

  openReviewDialog(vehicle) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      vehicle: vehicle
    }
    this.dialog.open(ReviewsModalBodyComponent, dialogConfig);
  }

  tabChanged(tabChangeEvent: MatTabChangeEvent) {



    if (tabChangeEvent.index == 0) {
      this.selectedVehicleReservationState = VehicleReservationState.Confirmed;
      this.getMyBooking(this.loggedInCustomer.customerID, VehicleReservationState.Confirmed)
      //this.myBookingsFilter = this.myBookings.filter(a=> a.vehicleReservationStateID == VehicleReservationState.Confirmed || a.vehicleReservationStateID == VehicleReservationState.Cancelled  );
    }
    else {
      if (tabChangeEvent.index == 1) {
        this.selectedVehicleReservationState = VehicleReservationState.Pickedup;
        this.getMyBooking(this.loggedInCustomer.customerID, VehicleReservationState.Pickedup)
        //this.myBookingsFilter = this.myBookings.filter(a=> a.vehicleReservationStateID == VehicleReservationState.Pickedup);
      }
      else {
        if (tabChangeEvent.index == 2) {
          this.selectedVehicleReservationState = VehicleReservationState.Returned;
          this.getMyBooking(this.loggedInCustomer.customerID, VehicleReservationState.Returned)
          //this.myBookingsFilter = this.myBookings.filter(a=> a.vehicleReservationStateID == VehicleReservationState.Returned || a.vehicleReservationStateID == VehicleReservationState.Closed);
        }
      }
    }
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(item => {
      item.unsubscribe();
    })

    this.intervals.forEach(item =>{
      clearInterval(item);
    })
  }

  onScroll() {

    this.pageNumber++;

    if (this.pageNumber <= Math.ceil(this.totalCount / this.pageSize)) {
      this.getMyBookingOnScroll(this.loggedInCustomer.customerID, this.selectedVehicleReservationState);
    }
  }





}

